import WorkWithUs from "@/app/trabaja-con-nosotros/page";

export const ROUTES = {
  home: {
    root: '/',
  },
  contact: {
    root: '/contacto',
  },
  aboutUs: {
    root: '/nosotros',
  },
  workWithUs: {
    root: '/trabaja-con-nosotros',
  },
  literature: {
    root: '/literatura',
    categories: (categorySlug: string) => `/literatura/${categorySlug}`,
    details: (categorySlug: string, literatureSlug: string) => `/literatura/${categorySlug}/${literatureSlug}`,
  },
  usedEquipmentsCertificate: {
    root: '/equipos-usados-certificados'
  },
  promotions: {
    root: '/promociones',
    details: (slug: string) => `/promociones/${slug}`
  },
  industries: {
    root: '/industrias',
    details: (slug: string) => `/industrias/${slug}`,
  },
  usedEquipments: {
    root: '/equipos-usados',
    details: (slug: string) => `/equipos-usados/${slug}`,
    used: (slug: string) => `/equipos-usados/usado/${slug}`
  },
  rentals: {
    root: '/rentas',
    categories: (slug: string) => `/rentas/${slug}`
  },
  technologySolutions: {
    root: '/soluciones-tecnologicas',
    details: (slug: string) => `/soluciones-tecnologicas/${slug}`
  },
  partsServices: {
    root: '/refacciones-y-servicios',
    details: (slug: string) => `/refacciones-y-servicios/${slug}`
  },
  partsServicesSubcategories: {
    details: (slugCategory: string, slugSubcategory: string) => `/refacciones-y-servicios/${slugCategory}/${slugSubcategory}`,
    visionLink: '/refacciones-y-servicios/soluciones-digitales-cat/visionlink/',
    sis2go: '/refacciones-y-servicios/soluciones-digitales-cat/cat-sis2go/',
    catApp: '/refacciones-y-servicios/soluciones-digitales-cat/cat-central-app/',
    static:{
      digitalSolutions: 'soluciones-digitales-cat',
      originalParts: 'refacciones-originales-cat',
    }
  },
  tires: {
    root: '/llantas',
    industries: (industrySlug: string) => `/llantas/${industrySlug}`,
    details: (industrySlug: string, tireSlug: string) => `/llantas/${industrySlug}/${tireSlug}`
  },
  products: {
    root: '/productos-nuevos',
    industry: (industrySlug: string | undefined) => `/productos-nuevos/${industrySlug}`,
    family: (industrySlug: string | undefined, familySlug: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}`,
    subfamily: (industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}/${subfamilySlug}`,
    productDetails: (productSlug: string, industrySlug: string | undefined) => !industrySlug ? `/producto-nuevo/${productSlug}` : `/producto-nuevo/${productSlug}/?industria=${industrySlug}`,
  },
  news: {
    root: '/noticias',
    categories: (categorySlug: string) => `/noticias/${categorySlug}`,
    details: (categorySlug: string, newsSlug: string) => `/noticias/${categorySlug}/${newsSlug}`,
  },
  brands: {
    root: '/productos-por-marca',
    brand: (brandSlug: string | undefined) => `/productos-por-marca/${brandSlug}`,
    industry: (brandSlug: string | undefined, industrySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}`,
    family: (brandSlug: string | undefined, industrySlug: string | undefined, familySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}/${familySlug}`,
    subfamily: (brandSlug: string | undefined, industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}/${familySlug}/${subfamilySlug}`
  },
  branches: {
    root: '/sucursales',
    branch: (typeSlug: string, branchSlug: string) => `/sucursales/${typeSlug}/${branchSlug}`,
    google: (latitude: number, length: number) => `https://www.google.com/maps?q=${latitude},${length}&hl=es;z=14&output=embed`,
  },
  external: {
    constructionTechnology: 'https://www.sitechnoroeste.com.mx/',
    googlePlayStore: 'https://play.google.com/store/apps/details?id=com.cat.digital.mobile.sis2go&hl=es',
    appleStore: 'https://apps.apple.com/es/app/cat-sis2go/id1528609895',
    microsoftStore: 'https://apps.microsoft.com/detail/9n6svzr1lfvc?hl=es-mx&gl=MX',
    visionLink: 'https://vl.cat.com/es-ES',
    si2go: 'https://sis2.cat.com/#',
    partsMatco: 'https://parts.cat.com/es/matco'
  }
} as const